import React, { useEffect } from 'react';
import {
    Box,
    Collapse,
    Icon,
    ListItemButton,
    ListItemText,
    useMediaQuery,
    useTheme,
} from '@mui/material';

import {
    KeyboardArrowDown
} from '@mui/icons-material';

import PermissionGuard from '../../contexts/PermissionContext';
import NonMobileFeature from '../popover/NonMobileFeature';


export default function SideList(props) {

    const { currentPage, open, setOpen, title, subtitle, data } = props

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))

    // SIDELIST FUNCTIONS
    const toggleList = () => {
        setOpen(!open)
    }

    useEffect(() => {
    }, [currentPage])

    return (
        <React.Fragment>
            <ListItemButton
                onClick={toggleList}
                sx={{
                    px: 3,
                    pt: 1.8,
                    pb:  1.8,
                    borderRadius: 1,
                    transition: '0.1s',
                    '&:hover, &:focus': { '& svg': { opacity: open ? 1 : 0 } },}} >
                <ListItemText
                    primary={title}
                    primaryTypographyProps={{
                        fontSize: 15,
                        fontWeight: 'bold',
                        lineHeight: '20px',
                        mb: '2px',
                    }}
                    secondary={subtitle}
                    secondaryTypographyProps={{
                        noWrap: false,
                        fontSize: 12,
                        lineHeight: '16px',
                        color: 'rgba(255,255,255,0.5)',
                    }}
                    sx={{ my: 0 }}
                />
                <KeyboardArrowDown
                    sx={{
                        mr: -1.5,
                        opacity: 0,
                        transform: open ? 'rotate(-180deg)' : 'rotate(0)',
                        transition: '0.3s',
                        pb: 0
                    }} />
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                { data.map((item) => (
                    <PermissionGuard permission={item?.permission}>
                        <Box display='flex' justifyContent='flex-start' marginLeft={3} key={item.label}>
                            <ListItemButton
                                disabled={item.desktoponly && isSm ? true : false}
                                onClick={item.link}
                                sx={{ py: 0, 
                                    minHeight: 32, 
                                    color: item.key===currentPage ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.7)', 
                                    bgcolor: item.key===currentPage ? 'rgb(71 132 96)' : null, 
                                    borderRadius: 1,
                                    '&:hover': { bgcolor: item.key===currentPage ? 'rgb(52 97 70)' : 'rgba(255,255,255,0.15)' },
                                    }}>
                                <Box 
                                    paddingRight="15px"
                                    paddingBottom="1px">
                                    <Icon sx={{ color: 'inherit', }}>
                                        {item.icon}
                                    </Icon>
                                </Box>
                                <ListItemText
                                    primary={item.label}
                                    primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }} />
                                
                            </ListItemButton>
                            {
                                item.desktoponly && isSm 
                                ? 
                                <NonMobileFeature/> 
                                : 
                                <></>
                            }
                        </Box>
                    </PermissionGuard>
                ))}
            </Collapse>
        </React.Fragment>
    );
}
